import { c as _c } from "react/compiler-runtime";
import useJourneyData from '~/hooks/useJourneyData';
export default function JourneyIntro() {
  const $ = _c(2);
  const {
    intro_text,
    featuredActivities
  } = useJourneyData();
  if (featuredActivities.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== intro_text) {
    t0 = <div className="hidden px-4 mt-4 md:block md:px-0 md:max-w-prose md:mt-8"><p className="mt-2">{intro_text}</p></div>;
    $[0] = intro_text;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}